import { DefaultSettings, settings } from '../../../settings/settings-util';
import ChannelRequestProcessor from './request-processor-channel';
import reducer from './reducers/index';
import InputProcessor from '../../../types/input-processor';
import Module from '../../../types/module';

export default class ChannelManager extends Module {
    _reqProc: InputProcessor;

    constructor(passedSettings: DefaultSettings = settings) {
        super(passedSettings, reducer);
        
        this._reqProc = new ChannelRequestProcessor(this._settings);
    }

    getRequestProcessor(): InputProcessor  {
        return this._reqProc;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/channel/src/channel.ts